import io from 'socket.io-client';
import { DIGITAL_SIGN_SOCKET_BASEURL } from '../constant/baseurl';

const digiSocket = io(DIGITAL_SIGN_SOCKET_BASEURL, {});
export default digiSocket;